import {
  PROJECT_SELECT_FETCH_STARTED,
  PROJECT_SELECT_FETCH_SUCCEEDED,
  PROJECT_SELECT_FETCH_FAILED,
  PROJECT_SELECT_CLEAR
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  projects: [],
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case PROJECT_SELECT_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case PROJECT_SELECT_FETCH_SUCCEEDED:
      return {
        ...state,
        status: statuses.succeeded,
        projects: action.payload
      };
    case PROJECT_SELECT_FETCH_FAILED:
      return { ...state, status: statuses.failed, projects: [], error: action.error };
    case PROJECT_SELECT_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
